import { combineReducers } from "@reduxjs/toolkit";
import { confirmReducer } from "./confirm";

export const leaveReducer = combineReducers({
  confirm: confirmReducer,
});
